/* RP - Responsable de proceso -  toma decisión de la(s) propuesta(s) asignadas a su rol */
/* Contenido - registro de pxf (detalles) */
/* VerRegistrar - Ventana de registro o visualización de la propuesta de cambio (botones Ver o Registrar) */

//*react- recursos
  import React, { useState, useCallback,useEffect } from "react";
  import { useDropzone } from "react-dropzone";
  import swal2 from "sweetalert2"; //npm install --save sweetalert2

  //*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";

/* import CargaArchivo from "../../../componentes/CargaArchivo"; */

//*clases 
  import ReactTooltip from "react-tooltip";
  import '../../../../css/mdi.css'; 
  import { Col, Row } from "react-bootstrap";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //'libreria' que cita el bote de basura
  import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"; //icono bote de basura 


//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
  import articulos from "../../../../datos/json/guidelines.json";
  //import Dropzone from "react-dropzone";

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)
  import decisionsServicio from "../../../../api/recursos/decisions/decisions.servicio"; 
  import decisionsStore from "../../../../api/recursos/decisions/decisions.store"; 

  import notificationsServicio from "../../../../api/recursos/notifications/notifications.servicio"; 
  import notificationsStore from "../../../../api/recursos/notifications/notifications.store"; 

  import filesServicio from "../../../../api/recursos/files/files.servicio"; 
  import filesStore from "../../../../api/recursos/files/files.store"; 

//*store's

//*interfaces
  interface propsVerRegistrar {
    tokenStore:any,
    idPxF:any,
    miPropuestaDetalle: any,      //la que viene de decisions
    propuestaDetallesFront: any,  //la que viene de proposals
    botonCierraSlidingPanel:any,
    recargaCiclos:any,
    recargaRPContenido:any,
    recargaRP:any,
    recargaPaginaSSC:any,
    recargaPaginaSSC_Not :any
  }
  
//*componente
export default function VerRegistrar(props: propsVerRegistrar){
  var _ = require('underscore');

  //*api store
      const { guardaUpdateRateProposalStore, 
              guardaSendRateProposalStore, 
              cambiapxfStore,
              frecUNDStore, cambiafrecUNDStore, frecUNDSelecStore, reiniciafrecUNDStore,
              generaObjErrorDecisionsStore } =  
          decisionsStore((state:any) =>( { 
              guardaUpdateRateProposalStore: state.guardaUpdateRateProposalStore,
              guardaSendRateProposalStore: state.guardaSendRateProposalStore,
              cambiapxfStore: state.cambiapxfStore,
              frecUNDStore: state.frecUNDStore,
              cambiafrecUNDStore: state.cambiafrecUNDStore,
              frecUNDSelecStore: state.frecUNDSelecStore,
              reiniciafrecUNDStore: state.reiniciafrecUNDStore,
              generaObjErrorDecisionsStore: state.generaObjErrorDecisionsStore
      }));

      const { guardaSendEmailStore, 
              generaObjErrorNotificationsStore } =  
          notificationsStore((state:any) =>( { 
              guardaSendEmailStore: state.guardaSendEmailStore,
              generaObjErrorNotificationsStore: state.generaObjErrorNotificationsStore
      }));   
      
      const { guardaUploadFilesDecisionStore, 
              generaObjErrorFilesStore, objErrorFilesStore } =  
          filesStore((state:any) =>( { 
              guardaUploadFilesDecisionStore: state.guardaUploadFilesDecisionStore,
              generaObjErrorFilesStore: state.generaObjErrorFilesStore,
              objErrorFilesStore: state.objErrorFilesStore
      }));   

  //*store's
  
  //*datos
    let bodyAPIGuardar:any = {
      "id":0, 
      "proposal":{ "id":0,  "evidence":null,  "quality":null, "decision":{ "id":null, "name":null, "commentary":null, "cycle":null, "files":null} } 
    };
   
  //*constantes y variables
    let etiRP = etiquetasSSC.RP;
    let etiGlobal = etiquetasSSC.Global;
    let x0:any, x1:any, x2:any, x3:any, x4:any, x5:any, x6:any, x7:any , x8:any, x9:any  = ''
    let msjError = "";  
    let msjAdvertencia = "";  
    let verificaCiclo = {id: null, name: ""};
    let myFileCopiaFront = [] as any;
    let filesNuevos:any = [];
    let bodyArchAPI:any = []; // la usamos por si el nos manda archivos guardados

  //*useState
    const [swRecarga, setSwRecarga] =  useState(false);
    const [swRecargaRPContenidoVerRegistrar, setSwRecargaRPContenidoVerRegistrar] =  useState(false); //usado para remasterizar esta página
    const [cargandoSpin,setCargandoSpin] = useState(false);

    const [abreSP, setAbreSP] = useState(false);
    const [miPropuestaDetalleFront,  setMiPropuestaDetalleFront] = useState(props.miPropuestaDetalle); //la que viene de decisions
    const [miPDProposalFront,  setMiPDProposalFront] = useState(props.miPropuestaDetalle.proposal);

    //catálogos a visualizar en el front
    const [miCatDecisionesFront,  setMiCatDecisionesFront] = useState(props.miPropuestaDetalle.proposal.miCatDecisiones);
    const [miCatCiclosFront,  setMiCatCiclosFront] =         useState(props.miPropuestaDetalle.proposal.miCatCiclos);
    const [miCatCiclosOtrosFront, setMiCatCiclosOtrosFront]= useState(props.miPropuestaDetalle.proposal.miCatCiclosOtros);
    const [miCatCiclosOtrosFrontHH, setMiCatCiclosOtrosFrontHH]= useState(props.miPropuestaDetalle.proposal.miCatCiclosOtrosHH);
    const [miCatCiclosOtrosFrontHHMM, setMiCatCiclosOtrosFrontHHMM]= useState(props.miPropuestaDetalle.proposal.miCatCiclosOtrosHHMM);
    const [miCatCiclosOtrosFrontAA, setMiCatCiclosOtrosFrontAA]= useState(props.miPropuestaDetalle.proposal.miCatCiclosOtrosAA);
    const [miCatCiclosOtrosFrontMM, setMiCatCiclosOtrosFrontMM]= useState(props.miPropuestaDetalle.proposal.miCatCiclosOtrosMM);
    const [miCatCiclosOtrosFrontDD, setMiCatCiclosOtrosFrontDD]= useState(props.miPropuestaDetalle.proposal.miCatCiclosOtrosDD);
    const [miCatEvidenciasFront,  setMiCatEvidenciasFront] = useState(props.miPropuestaDetalle.proposal.miCatEvidencias);
    const [miCatPrincipiosFront,  setMiCatPrincipiosFront] = useState(props.miPropuestaDetalle.proposal.miCatPrincipios);

    //elementos a visualizar en el front
    const [comentarioFront, setComentarioFront] = useState(miCatDecisionesFront[0].commentary);
    const [misArchivosDropzone, setMisArchivosDropzone] = useState(props.miPropuestaDetalle.proposal.decision.files); // la usamos por si el nos manda archivos guardados

    const [miDecisionFront, setMiDecisionFront] = useState(props.miPropuestaDetalle.proposal.decision);
    const [hhFront, setHhFront] = useState(props.miPropuestaDetalle.frecuenciaHH);
    const [hhmmFront, setHhmmFront] = useState(props.miPropuestaDetalle.frecuenciaHHMM);
    const [undFront, setUndront] = useState(props.miPropuestaDetalle.frecuenciaUND);
    const [aaFront, setAaFront] = useState(false);
    const [mmFront, setMmFront] = useState(false);
    const [ddFront, setDdFront] = useState(false);
    const [miCicloSelFront, setMiCicloSelFront] = useState(miDecisionFront.cycle);
    const [miCicloOtroSelFront, setMiCicloOtroSelFront] = useState(miDecisionFront.cycle);
    const [miCicloOtroSelFrontHH, setMiCicloOtroSelFrontHH] = useState(miDecisionFront.cycle);
    const [miCicloOtroSelFrontHHMM, setMiCicloOtroSelFrontHHMM] = useState(miDecisionFront.cycle);
    const [miCicloOtroSelFrontAA, setMiCicloOtroSelFrontAA] = useState({id:'', name:'', activo:false});
    const [miCicloOtroSelFrontMM, setMiCicloOtroSelFrontMM] = useState({id:'', name:'', activo:false});
    const [miCicloOtroSelFrontDD, setMiCicloOtroSelFrontDD] = useState({id:'', name:'', activo:false});
    const [miDatoHH, setMiDatoHH] = useState('');
    const [miDatoHHMM, setMiDatoHHMM] = useState('');
    const [miDatoAA, setMiDatoAA] = useState('');
    const [miDatoMM, setMiDatoMM] = useState('');
    const [miDatoDD, setMiDatoDD] = useState('');
    
    const [swBotonGuardarFront,  setSwBotonGuardarFront] = useState(props.miPropuestaDetalle.proposal.btnGuardar);
    const [swBotonEnviarFront,  setSwBotonEnviarFront] = useState(props.miPropuestaDetalle.proposal.swEnviar);
    const [swOtroCicloFront,  setSwOtroCicloFront] = useState(props.miPropuestaDetalle.proposal.otroCiclo);
    const [swOtroCicloFrontHH,  setSwOtroCicloFrontHH] = useState(props.miPropuestaDetalle.frecuenciaHH);
    const [swOtroCicloFrontHHMM,  setSwOtroCicloFrontHHMM] = useState(props.miPropuestaDetalle.frecuenciaHHMM);
    const [swOtroCicloFrontUND,  setSwOtroCicloFrontUND] = useState(props.miPropuestaDetalle.frecuenciaUND);

    const [abreDivPropuestaCompleta, setAbreDivPropuestaCompleta] = useState(false);
    const [swCambio, setSwCambio] = useState(false);
    const [swDropzoneAdvertencia, setSwDropzoneAdvertencia] = useState(true);

    const [errorFiles, setErrorFiles] = useState(false);
    
  //*useEffect
    useEffect(()=> { // al montar
      console.log('RD.Contenido.VerRegistra - monto');
      console.log('props.propuestaDetallesFront.frecuenciaHH',props.propuestaDetallesFront);
      //console.log('miCatCiclosOtrosFrontHH....',miCatCiclosOtrosFrontHH);
      //console.log('miCatCiclosOtrosFrontHHMM....',miCatCiclosOtrosFrontHHMM);
      const x = JSON.parse(JSON.stringify(miDecisionFront));
      if (props.miPropuestaDetalle.frecuenciaHH){
          let cadena = x.cycle.name;
          let paso = cadena.substring(cadena.length - 2);
          setMiDatoHH(paso);
          //console.log('----::::::::paso', paso);
          console.log('----::::::::miCicloOtroSelFront', miCicloOtroSelFront);
          console.log('----::::::::miDatoHH...', miDatoHH);
      }
      if (props.miPropuestaDetalle.frecuenciaHHMM){
          let cadena = miDecisionFront.cycle.name;
          let paso = cadena.substring(cadena.length - 4);
          setMiDatoHHMM(paso);
          //console.log('----::::::::paso', paso);
          console.log('----::::::::miCicloOtroSelFront', miCicloOtroSelFront);
          console.log('----::::::::miDatoHHMM...', miDatoHHMM)
      }
      /* if (props.miPropuestaDetalle.frecuenciaUND){
        if (miDecisionFront.cycle.name != undefined) {
            let cadena = miDecisionFront.cycle.name;
            let paso = cadena.substring(cadena.length - 4);
            setMiDatoAA(paso);
            //console.log('----::::::::paso', paso);
            console.log('----::::::::miCicloOtroSelFront', miCicloOtroSelFront);
            console.log('----::::::::miDatoHHMM...', miDatoHHMM)
        }
      } */
    },[]);
   
    useEffect(()=> {   //usado para renderizar
      console.log('renderizando RP.........................');
      setSwRecargaRPContenidoVerRegistrar(!swRecargaRPContenidoVerRegistrar);
     },[swRecarga]);

  //*funciones
    const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC
    const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana
    const recargaRP = () => { props.recargaRP() }
    const recargaRPContenido = () => { props.recargaRPContenido() }
  
    const recargaRPContenidoVerRegistrar = () => {
        setSwRecarga(!swRecarga);
        recargaRPContenido();
    }
  
    const armaComentario = (e:any) => {
      //console.log('e.target.value::',e.target.value);
      setComentarioFront(e.target.value);
      setSwCambio(!swCambio)//lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      //console.log('armaComentario:: ',comentarioFront);
    };

    const armaVerificaCiclo = () => {  //uso esta rutina en armaBodyGuardarEnAPI y botonEnviar, por eso la pongo aquí, dejando pasoCiclo global
      //alert('armaVerificaCiclo')
      verificaCiclo = {id: null, name: ""};
      let swPaso=false;
      if (miCicloSelFront.id==99999 || miCicloSelFront.id==null) {
         console.log('if');
          //primero veo que no exista el ciclo seleccionado en Otro dentro de los ciclos propuestos
          if (!undFront) { //aplica a todos menos a frecuencia Unica o No determinada
              miCatCiclosFront?.map((cc:any, indexCC1:any) => {
                if (cc.name == miCicloOtroSelFront.name) {
                    swPaso=true;
                    verificaCiclo.id = cc.id;        
                    verificaCiclo.name = cc.name;  
                }
              });
              if (swPaso == false) {
                  //console.log('if 2');
                  verificaCiclo.name = '';
                  if (!props.miPropuestaDetalle.frecuenciaHH && !props.miPropuestaDetalle.frecuenciaHHMM) { verificaCiclo.name = miCicloOtroSelFront.name };
                  if (props.miPropuestaDetalle.frecuenciaHH) { verificaCiclo.name = miCicloOtroSelFront.name + ' ' + miCicloOtroSelFrontHH.name };
                  if (props.miPropuestaDetalle.frecuenciaHHMM) { verificaCiclo.name = miCicloOtroSelFront.name + ' ' + miCicloOtroSelFrontHHMM.name } 
              }
          }
          else {
             //console.log('else..., frecUNDSelecStore', frecUNDSelecStore, miCicloOtroSelFrontAA);
              switch (frecUNDSelecStore) {
                case 'Anual':   verificaCiclo.name = miCicloOtroSelFrontAA.name; break;
                case 'Mensual': verificaCiclo.name = miCicloOtroSelFrontMM.name; break;
                case 'Diaria':  verificaCiclo.name = miCicloOtroSelFrontDD.name; break;
              }
          }
      }   
      else {
        verificaCiclo.id = miCicloSelFront.id;
        verificaCiclo.name = miCicloSelFront.name;
        //console.log('else');
      }
      console.log('***************************verificaCiclo', verificaCiclo);
    }

    const botonEnviar = () => {
      let bodyAPIEnviar= {id: 0, proposal: {send: true, id: 0}}

      //{id: 1, proposal: {send: true, id: 1229}}
      bodyAPIEnviar.id=  props.idPxF;
      bodyAPIEnviar.proposal.id= miPDProposalFront.id;
    
      setCargandoSpin(true);
      /* llamando al api: decisions/SendRateProposal */
      decisionsServicio.cargaSendRateProposal(props.tokenStore, bodyAPIEnviar)
        .then((response:any) => {
            if (response.status==200) {  //revisa si hay error
              guardaSendRateProposalStore(response.data).then( function(sendRateProposalFront:any) { 
                //let pasoDetalle = { sentOrden:2 }; // sent = 1-true 2-false para el manejo de la tabla (orden asc y desc)
                let pasoDetalle=2;
                cambiapxfStore(props.idPxF, miPDProposalFront.id, null, pasoDetalle, 'botonEnviarAPI'); 

              //desactivamos plantilla front ya que se envío ya no hay modificaciones
                miCatDecisionesFront.map((cd:any, indexCd:any) => {
                  cd.disabled = true;
                  if (cd.activo == false) 
                      cd.visible = false;
                }); 
                miCatEvidenciasFront.map((ce:any, indexCe:any) => {
                  ce.disabled = true;
                  if (ce.activo == false) 
                      ce.visible = false;
                }); 
                miCatPrincipiosFront.map((cp:any, indexCp:any) => {
                  cp.disabled = true;
                  if (cp.activo == false) 
                      cp.visible = false;
                }); 
                setSwBotonGuardarFront(false); //habilitar boton guardar en front
                setSwBotonEnviarFront(false); // hasta que grabe envia
                recargaRPContenido();
                recargaRP();

              //se genera una notificación & recarga de valores de notificaciones para el encabezado (campana)
                let bodyAPINot= {idproposal:0, idpf:0 }
                bodyAPINot.idproposal = miPDProposalFront.id;
                bodyAPINot.idpf = props.idPxF;
                setCargandoSpin(true);
                notificationsServicio.cargaSendEmail(props.tokenStore, bodyAPINot)
                  .then((response:any) => {
                      //console.log('response.................', response)
                      if (response.status==200){  //confirma que no hubo error
                          guardaSendEmailStore(response.data).then( function(sendEmailFront:any) { 
                              //console.log('genera el correo por medio del api', sendEmailFront );
                              recargaRPContenido();
                              recargaPaginaSSC_Not(); // para recargar las notificaciones (campana) en PaginaSSC
                             
                          }); 
                      }
                      setCargandoSpin(false);
                  })
                  .catch((ex) => {
                      console.log ("--catch - ex (cargaSendEmail): ", ex.response.status);
                      generaObjErrorNotificationsStore(ex.response, true, '', '', 'VerRegistrar-Notificatios/SendEmail','RP');
                      setCargandoSpin(false);
                      recargaPaginaSSC();
                  })
              
              //valida si se agrego un ciclo para agregarlo al catálogo
                armaVerificaCiclo();
                if (verificaCiclo.id==null && verificaCiclo.name!= '' ) {
                    props.recargaCiclos(); //funcion de ResponsableDeProcesoContenido
                }

                swal2
                  .fire({
                    icon: 'info',
                    cancelButtonColor: '#0077c8',
                    cancelButtonText: "Cerrar",
                    showCancelButton: true,
                    showConfirmButton:false,
                    width: "50%",
                    title: 'El registro del tipo de modificación se ha enviado al Responsable de Diseño para su documentación',
                  });
                  recargaRPContenido();  
              });     
            }    
            setCargandoSpin(false);
           
            recargaPaginaSSC_Not();
        })
        .catch((ex) => {
            console.log ("--catch - ex (cargaSendRateProposal): ", ex.response.status);
            generaObjErrorDecisionsStore(ex.response, true, '', '', 'VerRegistrar-Decisions/SendRateProposal','RP');
            setCargandoSpin(false);
            recargaPaginaSSC();
        })
    }

    const botonGuardar = () => {
      //alert('botonGuardar');
      window.scrollTo({top:0});
      validaPlantilla();
      if ( msjError != '' ) { //error no lo dejamos grabar solo mandamos mensahe
        swal2
          .fire({
            icon: 'error',
            cancelButtonColor: '#0077c8',
            cancelButtonText: "Cerrar",
            showCancelButton: true,
            showConfirmButton:false,
            width: "50%",
            title: 'Importante:',
            html: "<div>" + msjError + "</div>",
          })
      }
      else { //no tiene errores la plantilla; entonces podemos guardar
          //console.log('paso else');
          setSwBotonEnviarFront(false); 
          //primero: guardamos el archivo siempre y cuando la decisión = No Prevista
          if (miDecisionFront.id==3 && swDropzoneAdvertencia==false) {
              //guardaArchivosNoPrevista();
              let formData = new FormData();  
              formData.append("idpxf", props.idPxF);
              formData.append("idprop", miPDProposalFront.id);
              filesNuevos.map((f:any, indexF:any) => { formData.append("Files", f) });
              //console.log('---------------------------------formData', formData)
              if (filesNuevos.length > 0) { //tiene archivos guardamos
                  setCargandoSpin(true);
                  /* llamando al api: Files/UpdateRateProposal*/
                  setErrorFiles(false);
                  filesServicio.cargaUploadFilesDecision(props.tokenStore, formData)
                    .then((response:any) => {
                        if (response.status==200) {  //revisa si hay error
                            guardaUploadFilesDecisionStore(response.data).then( function(uploadFilesDecisionFront:any) { 
                              //console.log('..................uploadFilesDecisionFront', uploadFilesDecisionFront );
                              //segundo: guardamos el análisis
                              botonGuardarAnalisis();
                              cambiapxfStore(props.idPxF, miPDProposalFront.id, null, null, 'botonGuardarCambiaBtnEnviar');
                              recargaRPContenido();
                              //tercero: envío mensaje 
                              ventanaMensaje();
                            });     
                        }    
                        setCargandoSpin(false);
                    })
                    .catch((ex) => {
                        console.log ("--catch - ex (cargaInsertbyUser): ", ex.response.status);
                        generaObjErrorFilesStore(ex.response, true, '', '', 'VerRegistrar-Files/UpdateRateProposal','RP');
                        recargaRPContenidoVerRegistrar();
                        recargaPaginaSSC();
                        setCargandoSpin(false);
                    })
              }
              else { // aún no asigna archivo(s) pero guardamos el análisis
                botonGuardarAnalisis();
                cambiapxfStore(props.idPxF, miPDProposalFront.id, null, null, 'botonGuardarCambiaBtnEnviar');
                recargaRPContenido();
              }
          }
          else { 
            //segundo: guardamos el análisis
            botonGuardarAnalisis();
            cambiapxfStore(props.idPxF, miPDProposalFront.id, null, null, 'botonGuardarCambiaBtnEnviar');
            recargaRPContenido();
             //tercero: envío mensaje 
            ventanaMensaje();
          }
          recargaRPContenidoVerRegistrar();
          recargaRPContenido();
      } 
    }

    const ventanaMensaje = () =>  {
        if ( msjAdvertencia != '' ) { 
          swal2
            .fire({
              icon: 'info',
              cancelButtonColor: '#0077c8',
              cancelButtonText: "Cerrar",
              showCancelButton: true,
              showConfirmButton:false,
              width: "50%",
              title: 'El registro de la propuesta fue guardada:',
              html: "<div><b>Importante:</b><br/><br/>" + msjAdvertencia + "</div>",
            })
            //setSwBotonEnviarFront(false); // hasta que grabe envia
      }
      else {
          swal2
          .fire({
            icon: 'info',
            cancelButtonColor: '#0077c8',
            cancelButtonText: "Cerrar",
            showCancelButton: true,
            showConfirmButton:false,
            width: "50%",
            title: 'El registro de la propuesta fue guardada:',
            html: "<div>" + etiRP.mensajes[10].text + "</div>",
          })
          //cambiapxfStore(props.idPxF, miPDProposalFront.id, null, null, 'botonGuardarCambiaBtnEnviar');
          //setSwBotonEnviarFront(true); // hasta que grabe envia
      }
    }

    const botonGuardarAnalisis = () => {
      armaBodyGuardarEnAPI();
      setCargandoSpin(true);
      /* llamando al api: decisions/UpdateRateProposal*/
        decisionsServicio.cargaUpdateRateProposal(props.tokenStore, bodyAPIGuardar)
        .then((response:any) => {
          if (response.status==200) {  //revisa si hay error
              guardaUpdateRateProposalStore(response.data).then( function(updatebyUserFront:any) { 
                //console.log('***************************bodyAPIGuardar.proposal:', bodyAPIGuardar.proposal)
                //console.log('.........................updatebyUserFront',updatebyUserFront)
                let pasoDecision = bodyAPIGuardar.proposal.decision;
                let pasoCiclo = pasoDecision.cycle;
                let paso:any = {};
                if (pasoCiclo != null) 
                    paso = { id: pasoCiclo.id, name: pasoCiclo.name};
                else
                    paso = null;
                let pasoDetalle = { id: pasoDecision.id , name: pasoDecision.name, cycle: paso };
                setSwBotonGuardarFront(false);
                //idpxf:any, idprop: any, abierto:any, detalle:any, dondeViene:any
                cambiapxfStore(props.idPxF, miPDProposalFront.id, null, pasoDetalle, 'botonGuardarAPI'); 
                if ( msjAdvertencia == '' ) { setSwBotonEnviarFront(true) } // hasta que grabe envia
             
              });     
          }    
          setCargandoSpin(false);
        })
        .catch((ex) => {
            console.log ("--catch - ex (cargaInsertbyUser): ", ex.response.status);
            generaObjErrorDecisionsStore(ex.response, true, '', '', 'VerRegistrar-Decisions/UpdateRateProposal','RP');
            setCargandoSpin(false);
            recargaPaginaSSC();
        }) 

        //console.log('------------------------------')
        //console.log('miDecisionFront.id: ', miDecisionFront.id, '   swDropzoneAdvertencia: ', swDropzoneAdvertencia)
    }

        const armaBodyGuardarEnAPI = () => {
          //alert('botonGuardarEnAPI');
          //console.clear();
          //console.log('miDecisionFront: ',miDecisionFront);
          //console.log('miCicloSelFront :',miCicloSelFront);
          //console.log('miCicloOtroSelFront :',miCicloOtroSelFront);
          //console.log('miCicloOtroSelFrontHH :',miCicloOtroSelFrontHH);
          //console.log('miCicloOtroSelFrontHHMM :',miCicloOtroSelFrontHHMM);
          //console.log('miCatEvidenciasFront :',miCatEvidenciasFront);
          //console.log('miCatPrincipiosFront :',miCatPrincipiosFront);
          bodyAPIGuardar.id=  props.idPxF;
          bodyAPIGuardar.proposal.id= miPDProposalFront.id;

          /* determino el ciclo */
            armaVerificaCiclo();

          /* determino el ciclo */
            let pasoArchivos:any = [];
            //{id: 0, path: "1/1301", name: "Coco.pdf", classified: "", action: 1}
            let pasoArchivosElem = {id: null, path: null, name: null, classified: null, action: null};
            //ojo ver action (ummm como que me acuerdo de algo ver ssc v1)

          /* solo evidencias activas */
            let pasoEvidencias:any = [];
            miCatEvidenciasFront?.map((co:any, indexCo:any) => {
              if (co.activo) { pasoEvidencias.push(co.id) }
            });

          /* solo principios activos */
            let pasoPrincipios:any = [];
            let pasoPrincipiosElem= {id: null, idhit: 0};
            miCatPrincipiosFront?.map((cp:any, indexCp:any) => {
              pasoPrincipiosElem= {id: null, idhit: 0}
              if (cp.activo) {
                  pasoPrincipiosElem.id = cp.id;
                  pasoPrincipiosElem.idhit = cp.hitId;
                  pasoPrincipios.push(pasoPrincipiosElem);
              }    
            });

          //{ "id": 1, "name": "No procede", "commentary": "", "cycle": null, "files": null }
          switch (miDecisionFront.id) {
            case 1:
                  miDecisionFront.commentary = comentarioFront;
                  miDecisionFront.cycle = null;
                  miDecisionFront.files = null;
                break;
            case 2: 
                  miDecisionFront.commentary = null;
                  miDecisionFront.cycle = verificaCiclo;
                  miDecisionFront.files = null;
                  bodyAPIGuardar.proposal.quality= pasoPrincipios;
                break;
            case 3:
                  miDecisionFront.commentary = null;
                  miDecisionFront.cycle = verificaCiclo;
                  miDecisionFront.files =  bodyArchAPI;
                break;
          }
          bodyAPIGuardar.proposal.decision= miDecisionFront;
          bodyAPIGuardar.proposal.evidence= pasoEvidencias ;
          //console.log('-------------------------------listo el bodyArchAPI    ',bodyArchAPI);
          console.log('-------------------------------listo el bodyAPIGuardar ',bodyAPIGuardar);
        }

    const botonCerrar = () => {
      //alert('botonCerrar ');
      if (swBotonGuardarFront) { //si esta activo el botón guardar hay cambios...
        swal2.fire({
          text: "",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          width: '50%',
          html: "<div>" + etiRP.mensajes[0].text + "</div>",
        }).then((result) => {
          if (result.isConfirmed) {
              recargaRPContenido();
              props.botonCierraSlidingPanel('');
          }
              //setAbreSP(!abreSP);
          else
              return;
        })
      }
      else {  //cerramos SlipingPanel desde ResposnabelDeProcesoContenido
        recargaRPContenido();
        props.botonCierraSlidingPanel('');
      } 
     
    }

    const validaPlantilla = () => {
      //alert('validaPlantilla');
      msjError='';   
      msjAdvertencia='';
      if (miDecisionFront.id == null || miDecisionFront.id == undefined)
          msjError = msjError + etiRP.mensajes[1].text + '<br/>';
      switch (miDecisionFront.id) {
            case 1: //no procede
                  if (comentarioFront== null || comentarioFront== '')
                      msjAdvertencia = msjAdvertencia + etiRP.mensajes[2].text + '<br/>';
                break;
            case 2: // prevista
                  validaCiclo();
                  validaCicloOtro();
                  validaCicloOtroHH();
                  validaCicloOtroHHMM();
                  if (undFront) { 
                      validaCicloOtroAA();
                      validaCicloOtroMM();
                      validaCicloOtroDD();
                  };
                  validaEvidencias();
                  validaPrincipios();
                break;
            case 3: //no prevista
                  //alert('3');
                  validaCiclo();
                  validaCicloOtro();
                  validaCicloOtroHH();
                  validaCicloOtroHHMM();
                  if (undFront) { 
                    validaCicloOtroAA();
                    validaCicloOtroMM();
                    validaCicloOtroDD();
                  };
                  validaEvidencias();
                  //validaJustificacion(); //aquí se valida los archivos de dropzone
                  filesUpload(); //LLAMADO A ARCHIVOS DEL DROPZONE
                break;
      }
      setCargandoSpin(false);
      //console.log('msjError: ',msjError);
      //console.log('msjAdvertencia: ',msjAdvertencia);
    }

    const validaCiclo = () => {
      //alert('validaCiclo');
      //console.log('miCatCiclosFront:::::::::::::: ', miCatCiclosFront)
      if (miCatCiclosFront[0].activo){//esta en seleccionar
          msjError =  msjError + etiRP.mensajes[3].text + '<br/>';
          //console.log('....',msjError)
      }    
    }

    const validaCicloOtro = () => {
      //alert('validaCicloOtro');
      if (miCatCiclosFront[miCatCiclosFront.length-1].activo) {  //esta en otro
          //console.log('miCatCiclosOtrosFron--------------', miCatCiclosOtrosFront)
          //2 vertientes
          if (!undFront) {  //la normal todas las frecuencias excepto Única o No Determinada
              if (miCatCiclosOtrosFront[0].activo)  //esta en seleccionar
                  msjError = msjError + etiRP.mensajes[4].text + '<br/>';
          }
          else {
            if (frecUNDSelecStore == null ) {
                msjError = msjError + etiRP.mensajes[4].text + '<br/>';
            }

          }
       }
    }
    const validaCicloOtroHH = () => {
      //console.log('validaCicloOtroHH--------------',hhFront, '....', miCatCiclosOtrosFrontHH)
      if (hhFront) {
          if (miCatCiclosFront[miCatCiclosFront.length-1].activo) {  //esta en otro
            if (miCatCiclosOtrosFrontHH[0].activo)  //esta en seleccionar
                msjError = msjError +  etiRP.mensajes[11].text + '<br/>';
          }
      }
    }
    const validaCicloOtroHHMM = () => {
      if (hhmmFront) {
          if (miCatCiclosFront[miCatCiclosFront.length-1].activo) {  //esta en otro
            if (miCatCiclosOtrosFrontHHMM[0].activo)  //esta en seleccionar
                msjError = msjError + etiRP.mensajes[11].text + '<br/>';
          }
      }
    }

    const validaCicloOtroAA = () => {
      //console.log('validaCicloOtroAA--------------',frecUNDSelecStore, '....', miCatCiclosOtrosFrontAA)
      if (frecUNDSelecStore=='Anual') {
          if (miCatCiclosFront[miCatCiclosFront.length-1].activo) {  //esta en otro
            if (miCatCiclosOtrosFrontAA[0].activo)  //esta en seleccionar
                msjError = msjError +  etiRP.mensajes[12].text + '<br/>';
          }
      }
    }
    const validaCicloOtroMM = () => {
      //console.log('validaCicloOtroMM--------------',frecUNDSelecStore, '....', miCatCiclosOtrosFrontMM)
      if (frecUNDSelecStore=='Mensual') {
          if (miCatCiclosFront[miCatCiclosFront.length-1].activo) {  //esta en otro
            if (miCatCiclosOtrosFrontMM[0].activo)  //esta en seleccionar
                msjError = msjError +  etiRP.mensajes[13].text + '<br/>';
          }
      }
    }
    const validaCicloOtroDD = () => {
      //console.log('validaCicloOtroDD--------------',frecUNDSelecStore, '....', miCatCiclosOtrosFrontDD)
      if (frecUNDSelecStore=='Diaria') {
          if (miCatCiclosFront[miCatCiclosFront.length-1].activo) {  //esta en otro
            if (miCatCiclosOtrosFrontDD[0].activo)  //esta en seleccionar
                msjError = msjError +  etiRP.mensajes[14].text + '<br/>';
          }
      }
    }

    const validaEvidencias = () => {
      let swActivo = false;
      miCatEvidenciasFront.map((ce:any, indexCe:any) => {
        //console.log(ce);
        if (ce.activo)
            swActivo = true;
      });
      if (swActivo==false)
          msjAdvertencia = msjAdvertencia + etiRP.mensajes[6].text + '<br/>';
    }

    const validaPrincipios = () => {
          //alert('validaPrincipios')
          let swActivo = false;
          let msj = etiRP.mensajes[8].text;
          //console.log('miCatPrincipiosFront',miCatPrincipiosFront);
          miCatPrincipiosFront.map((cp:any, indexCP:any) => {
            if (cp.activo) {
                //console.log('if cp.id',cp.id);
                swActivo = true;
                if (cp.hitOpciones[0].activo==false && cp.hitOpciones[1].activo==false && indexCP != 5) {
                    msj = msj + '&nbsp;&nbsp;&nbsp;&nbsp;<i>-&nbsp;' + cp.name + '</i><br/>';
              }
            }    
          });
          if (swActivo == false)
            msjAdvertencia = msjAdvertencia + etiRP.mensajes[7].text + '<br/>';
          if (msj != etiRP.mensajes[8].text)  //se agregaron elementos de validación
            msjAdvertencia = msjAdvertencia + msj + '<br/>';          
    }

    const cambiaCheckEvidencias = (e:any) => {
      //alert('cambiaRadioDecision:' + e.target.id);
      //console.log('e.target.id::', e.target.id);
      //console.log('e.target.value::', e.target.value);
      //catE_1301_1
      let miCheckId = e.target.id;
      //console.log('miCheckId.....', miCheckId)
      let posP = miCheckId.indexOf('_');
      //console.log('**posP.....', posP)
      let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
      //console.log('**paso.....', paso)
      //console.log('**paso.length.....', paso.length)
      let posC = paso.indexOf('_');
      //console.log('**posC.....', posC)
      let pxfId = paso.substr( 0, posC );
      let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
      //console.log('*****propuestaId.....', pxfId)
      //console.log('*****catalogoId.....', catalogoId)

      miCatEvidenciasFront.map((ce:any, indexCe:any) => {
        if (ce.id == catalogoId) 
            ce.activo = !ce.activo;
      }); 
      setSwCambio(!swCambio);
      setSwBotonGuardarFront(true);
      setSwBotonEnviarFront(false);
      //console.log('cambiaCheckEvidencias:: ', miCatEvidenciasFront)
    };

    const cambiaCheckPrincipios = (e:any) => {
      //alert('cambiaRadioDecision:' + e.target.id);
      console.clear();
      //console.log('e.target.id::', e.target.id);
      //console.log('e.target.value::', e.target.value);
      let valor = e.target.value;
      //catP_1301_1
      let miCheckId = e.target.id;
      //console.log('miCheckId.....', miCheckId)
      let posP = miCheckId.indexOf('_');
      //console.log('**posP.....', posP)
      let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
      //console.log('**paso.....', paso)
      //console.log('**paso.length.....', paso.length)
      let posC = paso.indexOf('_');
      //console.log('**posC.....', posC)
      let pxfId = paso.substr( 0, posC );
      let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
      //console.log('*****propuestaId.....', pxfId)
      //console.log('*****catalogoId.....', catalogoId)
      miCatPrincipiosFront.map((cp:any, indexCp:any) => {
        if (cp.id == catalogoId) {
          cp.activo = !cp.activo;
          if (cp.activo==false) { // si lo deactivo quito los valores de incremena o decrementa
              cp.hitOpciones[0].activo = false;
              cp.hitOpciones[1].activo = false;
              cp.hitId=0;
          }
        }    
      }); 
      if (catalogoId == 6 && valor) {    
          miCatPrincipiosFront.map((cp:any, indexCp2:any) => {
            if (cp.id != catalogoId) {
                cp.activo = false
                cp.hitOpciones[0].activo = false;
                cp.hitOpciones[1].activo = false;
                cp.hitId=0;
            }
          });
      }
      else { miCatPrincipiosFront[5].activo = false }
     
      setSwCambio(!swCambio);
      setSwBotonGuardarFront(true);
      setSwBotonEnviarFront(false);
      //console.log('cambiaCheckPrincipios:: ', miCatPrincipiosFront)
    };

    const cambiaCiclo= (e:any) => {
      //console.log('e.target::',e.target);
      //alert('cambiaRadioDecision:' + e.target.id);  //este solo guarda el id del select no del option
      //console.log('e.target.value::',e.target.value); //ojo solo de aquí obtengo la selección del option en el value puse el id del catálogo
      //opcC_1301_1
      let miCheckId = e.target.id;
      let posP = miCheckId.indexOf('_');
      let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
      let posC = paso.indexOf('_');
      let pxfId = paso.substr( 0, posC );
      let catalogoId = e.target.value;
      //console.log('*****propuestaId.....', pxfId)
      //console.log('*****catalogoId.....', catalogoId)

      setMiCicloOtroSelFront({id: null, name: null, state_cycle: null, pt_md: null});
      miCatCiclosFront.map((cc:any, indexCC:any) => {
        if (cc.id == catalogoId){ 
            cc.activo = true;
            setMiCicloSelFront(cc); //{id: cc.id, name: cc.name, state_cycle: cc.state_cycl, pt_md: cc.pt_md}
        }    
        else 
            cc.activo = false
      }); 
      if (catalogoId==99999){  //opción "Otro"
          miCatCiclosOtrosFront.map((co:any, indexCO:any) => { co.activo = false });
          miCatCiclosOtrosFront[0].activo = true;
          setSwOtroCicloFront(true);
          if (props.miPropuestaDetalle.frecuenciaHH) {
              miCatCiclosOtrosFrontHH.map((co:any, indexCO2:any) => { co.activo = false });
              miCatCiclosOtrosFrontHH[0].activo = true;
              setSwOtroCicloFrontHH(true);
          };
          if (props.miPropuestaDetalle.frecuenciaHHMM) {
            miCatCiclosOtrosFrontHHMM.map((co:any, indexCO3:any) => { co.activo = false });
            miCatCiclosOtrosFrontHHMM[0].activo = true;
            setSwOtroCicloFrontHHMM(true);
        };

      }    
      else{
          setSwOtroCicloFront(false)
          setSwOtroCicloFrontHH(false)
          setSwOtroCicloFrontHHMM(false)
      }
      setSwCambio(!swCambio)//lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      //console.log('cambiaCiclo:: ', miCatCiclosFront);
    };

    const cambiaCicloOtro= (e:any) => {
      console.log('e.target::',e.target);
      //alert('cambiaRadioDecision:' + e.target.id);  //este solo guarda el id del select no del option
      //console.log('e.target.value::',e.target.value); //ojo solo de aquí obtengo la selección del option en el value puse el id del catálogo
      //opcC_1301_1
      let miCheckId = e.target.id;
      let posP = miCheckId.indexOf('_');
      let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
      let posC = paso.indexOf('_');
      let pxfId = paso.substr( 0, posC );
      let catalogoId = e.target.value;
      console.log('*****propuestaId.....', pxfId)
      console.log('*****catalogoId.....', catalogoId)

      miCatCiclosOtrosFront.map((cco:any, indexCCO:any) => {
        console.log ('cco.id', cco.id, '...indexCCO...',indexCCO , '....',props.miPropuestaDetalle.frequencyformat );
        /* if (props.miPropuestaDetalle.frequencyformat != 'AAAA-MM-DD')  */
        if (cco.id == catalogoId) {
            console.log ('if');
            cco.activo = true
            setMiCicloOtroSelFront({id: null, name: cco.name, state_cycle: null, pt_md: null});
        }    
        else { cco.activo = false };
        
      }); 
      //console.log('sali');
      setSwCambio(!swCambio) //lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      console.log('cambiaCicloOtro:: ', miCatCiclosOtrosFront);
    };

    const cambiaCicloOtroHH= (e:any) => {
      let pasoHH = {id: null, name: null, activo:true};
      setMiDatoHH('');
      setMiCicloOtroSelFrontHH(pasoHH);
      miCatCiclosOtrosFrontHH.map((ccohh:any, indexCCOhh:any) => {
        if (ccohh.id == e.target.value) {
            ccohh.activo = true
            pasoHH.id = ccohh.id;
            pasoHH.name = ccohh.name;
            setMiCicloOtroSelFrontHH(pasoHH);
        }    
        else { ccohh.activo = false };
      });
      setSwCambio(!swCambio) //lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      //console.log('cambiaCicloOtro:: ', miCatCiclosOtrosFront);
      recargaRPContenidoVerRegistrar();
    };

    const cambiaCicloOtroHHMM= (e:any) => {
      let pasoHHMM = {id: null, name: null, activo:true};
      setMiDatoHHMM('');
      setMiCicloOtroSelFrontHHMM(pasoHHMM);
      miCatCiclosOtrosFrontHHMM.map((ccomm:any, indexCCOmm:any) => {
        if (ccomm.id == e.target.value) {
            ccomm.activo = true
            pasoHHMM.id = ccomm.id;
            pasoHHMM.name = ccomm.name;
            setMiCicloOtroSelFrontHH(pasoHHMM);
        }    
        else { ccomm.activo = false };
      });
      setSwCambio(!swCambio) //lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      //console.log('cambiaCicloOtro:: ', miCatCiclosOtrosFront);
      recargaRPContenidoVerRegistrar();
    };

    const cambiaCicloOtroAA= (e:any) => {
      let pasoAA:any = {id: null, name: null, activo:true};
      setMiDatoAA('');
      setMiCicloOtroSelFrontAA(pasoAA);
      miCatCiclosOtrosFrontAA.map((ccoaa:any, indexCCOAA:any) => {
        if (ccoaa.id == e.target.value) {
            ccoaa.activo = true
            pasoAA.id = ccoaa.id;
            pasoAA.name = ccoaa.name;
            setMiCicloOtroSelFrontAA(pasoAA);
        }    
        else { ccoaa.activo = false };
      });
      setSwCambio(!swCambio) //lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      recargaRPContenidoVerRegistrar();
      //console.log('miCicloOtroSelFrontAA:: ', miCicloOtroSelFrontAA);

    };
    const cambiaCicloOtroMM= (e:any) => {
      let pasoMM:any = {id: null, name: null, activo:true};
      setMiDatoMM('');
      setMiCicloOtroSelFrontMM(pasoMM);
      miCatCiclosOtrosFrontMM.map((ccomm:any, indexCCOMM:any) => {
        if (ccomm.id == e.target.value) {
            ccomm.activo = true
            pasoMM.id = ccomm.id;
            pasoMM.name = ccomm.name;
            setMiCicloOtroSelFrontMM(pasoMM);
        }    
        else { ccomm.activo = false };
      });
      setSwCambio(!swCambio) //lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      
      recargaRPContenidoVerRegistrar();
      console.log('miCatCiclosOtrosFrontMM:: ', miCatCiclosOtrosFrontMM);
    };
    const cambiaCicloOtroDD= (e:any) => {
      let pasoDD:any = {id: null, name: null, activo:true};
      setMiDatoDD('');
      setMiCicloOtroSelFrontDD(pasoDD);
      miCatCiclosOtrosFrontDD.map((ccodd:any, indexCCODD:any) => {
        if (ccodd.id == e.target.value) {
            console.log ('if');
            ccodd.activo = true
            pasoDD.id = ccodd.id;
            pasoDD.name = ccodd.name;
            setMiCicloOtroSelFrontMM(pasoDD);
        }    
        else { ccodd.activo = false };
      });
      setSwCambio(!swCambio) //lo uso de puente para que recargue el front y se lleve el dato
      setSwBotonGuardarFront(true); //habilitar boton guardar en front
      setSwBotonEnviarFront(false); // hasta que grabe envia
      //console.log('cambiaCicloOtro:: ', miCatCiclosOtrosFront);
      recargaRPContenidoVerRegistrar();
    };
       
    const cambiaRadioDecision = (e:any) => {
      //alert('cambiaRadioDecision:' + e.target.id);
      //console.log('e.target.id::', e.target.id);
      //console.log('e.target.value::', e.target.value);
      //catD_1301_1
      
      setSwOtroCicloFront(false);
      setSwOtroCicloFrontHH(false);
      setSwOtroCicloFrontHHMM(false);
      reiniciafrecUNDStore();
      let miCheckId = e.target.id;
      //console.log('miCheckId.....', miCheckId)
      let posP = miCheckId.indexOf('_');
      //console.log('**posP.....', posP)
      let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
      //console.log('**paso.....', paso)
      //console.log('**paso.length.....', paso.length)
      let posC = paso.indexOf('_');
      //console.log('**posC.....', posC)
      let pxfId = paso.substr( 0, posC );
      let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
      //console.log('*****propuestaId.....', pxfId)
      //console.log('*****catalogoId.....', catalogoId)
      //inicializamos ciclos por el cambio de decisión
        miCatCiclosFront.map((cc:any, indexCO:any) => { cc.activo = false });  
        miCatCiclosOtrosFront.map((co:any, indexCO2:any) => { co.activo = false }); 
        miCatCiclosOtrosFrontHH.map((co:any, indexCO3:any) => { co.activo = false }); 
        miCatCiclosOtrosFrontHHMM.map((co:any, indexCO4:any) => { co.activo = false }); 
        miCatCiclosFront[0].activo = true;
        miCatCiclosOtrosFront[0].activo = true;
        if (props.propuestaDetallesFront.frecuenciaHH) { miCatCiclosOtrosFrontHH[0].activo = true };
        if (props.propuestaDetallesFront.frecuenciaHHMM) { miCatCiclosOtrosFrontHHMM[0].activo = true };
        setMiCicloSelFront({id: null, name: null, state_cycle: null, pt_md: null});
        setMiCicloOtroSelFront({id: null, name: null, state_cycle: null, pt_md: null});
        if (props.propuestaDetallesFront.frecuenciaHH) { 
            miCatCiclosOtrosFrontHH[0].activo = true;
            setMiCicloOtroSelFrontHH({id: null, name: null, state_cycle: null, pt_md: null});
        };
        if (props.propuestaDetallesFront.frecuenciaHHMM) { 
            miCatCiclosOtrosFrontHHMM[0].activo = true;
            setMiCicloOtroSelFrontHHMM({id: null, name: null, state_cycle: null, pt_md: null});
        };
        setSwCambio(!swCambio);

      miCatDecisionesFront.map((cd:any, indexCd:any) => {
        if (cd.id == catalogoId) {
            cd.activo = true
            setMiDecisionFront(cd);
           //console.log('miDecisionFront....',miDecisionFront)
        }    
        else 
            cd.activo = false
      }); 
      setSwCambio(!swCambio);
      setSwBotonGuardarFront(true);
      setSwBotonEnviarFront(false);
      //console.log('cambiaRadioDecision:: ', miCatDecisionesFront)
    };

    const cambiaRadioPrincipiosHit = (e:any) => {
      //alert('cambiaRadioDecision:' + e.target.id);
      //console.log('e.target.id::', e.target.id);
      //console.log('e.target.value::', e.target.value);
      //catD_1301_1_-1
      let miCheckId = e.target.id;
      //console.log('miCheckId.....', miCheckId)
      let posP = miCheckId.indexOf('_');
      //console.log('**posP.....', posP)
      let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
      //console.log('**paso.....', paso)
      //console.log('**paso.length.....', paso.length)
      let posC = paso.indexOf('_');
      //console.log('**posC.....', posC)
      let paso2 = paso.substr(posC+1, paso.length-posC-1 );
      //console.log('**paso2.....', paso2);
      //console.log('**paso2.length.....', paso2.length)
      let posD = paso2.indexOf('_');
      //console.log('**posD.....', posD)
      let pxfId = paso.substr( 0, posC );
      let catalogoId = paso2.substr(0, posD );
      let hitId = paso2.substr(posD+1, paso2.length-1 );
      //console.log('*****propuestaId.....', pxfId)
      //console.log('*****catalogoId.....', catalogoId)
      //console.log('*****hitId.....', hitId)
      miCatPrincipiosFront.map((cd:any, indexCd2:any) => {
        if (cd.id == catalogoId) {
          if (hitId == 1){
                cd.hitOpciones[0].activo = true;
                cd.hitOpciones[1].activo = false;
                cd.hitId = 1;
          }
          else {
               cd.hitOpciones[0].activo = false;
               cd.hitOpciones[1].activo = true;
               cd.hitId = -1;
          }
        }
      }); 
      setSwCambio(!swCambio);
      setSwBotonGuardarFront(true);
      setSwBotonEnviarFront(false);
      //console.log('miCatPrincipiosFront:: ', miCatPrincipiosFront)
    };
   
    const ligaPropuestaDeCambioCompleta = () => {
      setAbreDivPropuestaCompleta(!abreDivPropuestaCompleta);
    }

    const armaBodyArchivosAPI = ( archAPI: any, archDrop: any, archNvo: any) => {
      //compara los dos arreglos para armar el body que ocupa: Decisions/UpdateRateProposal/es
      //console.log('archAPI:  ', archAPI);
      //console.log('archDrop: ', archDrop);
      //console.log('archNvo:  ', archNvo);
      let swBaja = true;
      //para las bajas
      if (archAPI.length>0){
          archAPI.map((a:any, indexA:any) => {
              swBaja = true;
              archDrop.map((d:any, indexD:any) => { if (a.id == d.id ) { swBaja = false } }); 
              if (swBaja) { a.action = 2 };
          });
      }
      //para las altas
      const path = props.idPxF + "/" + miPDProposalFront.id; 
      if (archNvo.length != 0) { 
        archNvo.map((n:any, indexN:any) => { 
          archAPI.push ({ "id": indexN,  "path": path, "name": n.name, "classified":"", "action":1})
        })  
      };

      //console.log(':::::archAPI:  ', archAPI);
      bodyArchAPI = archAPI;
    }
    
    const cambiaRadioFrecuenciaUND = (e:any) => {
      //alert('cambiaRadioFrecuenciaUND:' + e.target.id);
      let frec = e.target.id;
      cambiafrecUNDStore(frec);
      setSwCambio(!swCambio);
      setSwBotonGuardarFront(true);
      setSwBotonEnviarFront(false);
      recargaRPContenidoVerRegistrar();
      
    };

    //-----------------DROPZONE---------------------INICIO EGGP
     //*constantes y variables
        let filesIn = [] as any; //este elemento se uso para cargar archivos inválidos (puede omitirse)
        let myFileCopia = [] as any; //copia de myFile (que es donde se guarda la lista de archivos cargados por el usuario) usada para hacer recorridos y comparaciones sin afectar el arreglo myFile

     //*useState
        const [myFiles, setMyFiles] = useState(misArchivosDropzone); //guarda el listado de elementos (archivos) cargados por el usuario
        const [filesInvalid, setFilesInvalid] = useState([] as any); //este elemento se uso para cargar archivos inválidos
      
     //*funciones:
        function MyDropzone() {
          //--useCallback  //ya traemos los archivos (acceptedFiles acumula lo del cuadro de dialogo)
          const onDrop = useCallback(
            (acceptedFiles) => {
              let acceptedFilesTemp: any = [];
              let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
              acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

              setSwBotonGuardarFront(true);
            
              setSwDropzoneAdvertencia(false);

              acceptedFilesTemp.map((aft:any, indexAft:any) => {
                aft.action=1;
                aft.id = indexAft;
                aft.action = 1;
                //aft.path = pathNvos;
                aft.classified = '';
              });

              if (myFiles.length != 0) {
                setSwBotonEnviarFront(false);
                //console.log(':::: acceptedFilesTemp ', acceptedFilesTemp ) ;
                //*el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado 
                for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
                  if (
                    myFiles.findIndex(
                      (mf: any) =>
                        mf.name.toLowerCase() ===
                        acceptedFilesTemp[i].name.toLowerCase()
                    ) >= 0
                  ) {
                    filesCarg = filesCarg + 1;
                    acceptedFiles.splice(
                      acceptedFiles.indexOf(acceptedFilesTemp[i]),
                      1
                    );
                  }
                }
              }
              /* acumula de acceptedFiles a myFiles */
              setMyFiles([...myFiles, ...acceptedFiles]);
            },
            [myFiles]
          );
          //--constantes de funcionalidades del dropzone, abre la ventana etc.
          const { getRootProps, getInputProps } = useDropzone({ onDrop });
          //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
          const removeFile = (file: any) => () => {
            //alert('removeFile');
            setSwBotonGuardarFront(true);
            let x = etiGlobal.dropZone[11].desc;
            swal2.fire({
              text: "",
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Si",
              cancelButtonText: "No",
              // width: widthSwal,
              width: "40%",
              html: "<div>" + etiGlobal.dropZone[11].desc + "</div>",
            }).then((result) => {
              if (result.isConfirmed) {
                const newFiles = [...myFiles]; //arreglo de paso
                newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
                setMyFiles(newFiles); //uso común del useState, actualiza myFiles
                //console.log("newFiles *******", newFiles.length);
                if (newFiles.length == 0) {
                  // lo que hacemos en caso de quedar vacío
                  //console.log(  "removeFile: que haré si se eliminan todos los elementos"  );
                  setSwDropzoneAdvertencia(true);
                  setSwBotonEnviarFront(false);
                }
              }
            });
          };
          //--genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
          //--cada vez que se renderiza myfiles genera esta función
          const files = myFiles.map((file: any, indexFiles:any) => (
            <li key={file.name}>
              <Row>
                <Col sm={10} className="small align-1">
                  {file.name}
                </Col>
                <Col sm={2}>
                  <button  title={etiGlobal.dropZone[5].desc}   onClick={removeFile(file)}  className="btn rounded-pill " >
                    <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2"  style={{ fontSize: "16px" }}  />
                  </button>
                </Col>
              </Row>
            </li>
          ));
          //--vista: -pintado del dropzone (adecuado a nuestro diseño)
          return (
            <>          
              <div className=" dropzone dz-message">
                <section className="container backcolor-blue-7">
                  <div
                    {...getRootProps({ className: " align-3" })}
                    className="spanDrop"             
                  >
                    <input {...getInputProps()} />
                    <div className="pt-25" >                  
                      <div >{etiGlobal.dropZone[7].desc}</div>
                    </div>                
                    <br />
                  
                  </div>
                  <aside className="backcolor-blue-7">
                    {/* nuestro listado que vamos acumulando*/}
                    <ul id="files">{files}</ul>
                  </aside>
                </section>
              </div>
            </>
          );
        }
        const filesUpload = () => {
          filesIn = [] as any;
          myFileCopia = [] as any;
          setFilesInvalid([]);
          myFileCopia = [...myFiles];
          //console.log("myFileCopia..---------------",myFileCopia, filesIn.length);
          if (myFileCopia.length===0){
              msjAdvertencia = msjAdvertencia + etiGlobal.dropZone[20].desc + '<br/>';
              setSwDropzoneAdvertencia(false);
              //console.log('..............SwDropzoneAdvertencia', swDropzoneAdvertencia)
          }
          else {  
            if (filesIn.length > 0) {
              //se encontraron archivos no válidos
              swal2.fire({
                text: "",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Continuar",
                cancelButtonText: "Cancelar",
                //width: widthSwal,
                width: "40%",
                html:
                "<div>" +
                etiGlobal.dropZone[8].desc +
                " <strong>" +
                filesIn.length +
                "</strong>" +
                etiGlobal.dropZone[17].desc +
                "<br></br>" +
                etiGlobal.dropZone[18].desc +
                "<br></br>" +
                etiGlobal.dropZone[19].desc +
                "</div>",
              }).then((result) => {
                if (result.isConfirmed) {
                  //setOpenDivLoading(true);
                  for (let f = filesIn.length - 1; f >= 0; f--) {
                    myFileCopia.splice(filesIn[f].idx, 1);
                  }
                  setMyFiles(myFileCopia);
                  setFilesInvalid(filesIn);
                  filesUploadContinue();
                  setSwRecarga(!swRecarga);
                } else {
                  for (let f = filesIn.length - 1; f >= 0; f--) {
                    myFileCopia.splice(filesIn[f].idx, 1);
                  }
                  setMyFiles(myFileCopia);
                  //console.log("files....", setMyFiles(myFileCopia))
                  return;
                }
              });
            }
            //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
            else {
              setMyFiles(myFileCopia);
              setFilesInvalid(filesIn);
              filesUploadContinue();
              setSwRecarga(swRecarga);
            }
          }
        };
        const filesUploadContinue = () => {  
          if (myFileCopia.length===0){
              msjAdvertencia = msjAdvertencia + etiGlobal.dropZone[20].desc + '<br/>';
          }
          else{ 
              filesIn = [] as any; 
              filesIn=myFileCopia; //aquí tenemos que hay en dropzone (ya quitando los que elimino por el bote y con los nuevos)
              console.log("eggp filesIn-----------",filesIn);
              console.log(":::misArchivosDropzone-----------",misArchivosDropzone); //aquí los que traemos del api
              myFileCopiaFront =  [...myFiles];
              filesNuevos = _.filter(filesIn, function(f:any) { return f.action == 1 });
              console.log(":::filesNuevos-------------------",filesNuevos);
              armaBodyArchivosAPI(misArchivosDropzone, filesIn, filesNuevos);//usado para armar la parte del file que ocupo el body del api
              console.log(":::bodyArchAPI-------------------",bodyArchAPI); //aquí la lista completa con sus respectivos códigos en action 
              setSwRecarga(!swRecarga)
          }   
        }     
    //-----------------DROPZONE---------------------FIN

  //**vista 
    return (
     <>
      {/* subencabezado: acronimo & frecuencia & nombre del proceso */}
        <div>
            <h4>{miPropuestaDetalleFront.acronym} / {miPropuestaDetalleFront.frequencyname}</h4>
            <h5 className="color-azul5">{miPropuestaDetalleFront.processname} &nbsp;
              <span className={miPropuestaDetalleFront.clasexEstatusIcono}>
                  {miPropuestaDetalleFront.estatusProceso} </span>
            </h5>
            <hr />
        </div>

      {/* contenido */}
        <div id='SlidingPanel_contenido'>
          {/* <p>miDecisionFront.id.........{miDecisionFront.id}................</p>
              <p>miDecisionFront.cycle.id...{miDecisionFront.cycle.id}..........</p>
              <p>miDecisionFront.cycle.name.{miDecisionFront.cycle.name}........</p>
              <p>miCicloSelFront.id.........{miCicloSelFront.id}................</p>
              <p>miCicloSelFront.name.......{miCicloSelFront.name}..............</p>
              <p>miCicloOtroSelFront.id.....{miCicloOtroSelFront.id}............</p> 
              <p>miCicloOtroSelFront.name...{miCicloOtroSelFront.name}..........</p>  */}

          {/* Propuesta de cambio completa */}
            <div>
              <a onClick={() => ligaPropuestaDeCambioCompleta() } title='Abre ventana con propuesta de cambio' className="divLigaPropCambio">{etiRP.contenido[10].text}
              <i className="mdi mdi-chevron-down font-size-16 color-azul3"></i></a>
              <br/>
              {abreDivPropuestaCompleta &&
                  (<>
                    <div className="margin-03r jumbotron">
                      <div className="text-right">
                        <a onClick={() => ligaPropuestaDeCambioCompleta() } className="h2 text-right color-azul3"> <i className="mdi mdi-chevron-up  "></i></a>
                      </div>
                      <p><span className="color-azul3"> {etiRP.etiquetas[4].text} </span> &nbsp;
                        <span> {props.propuestaDetallesFront.folio} </span>  &nbsp; &nbsp;
                        <span className="color-azul3"> {etiRP.etiquetas[5].text} </span> &nbsp;
                        <span> {props.propuestaDetallesFront.fecha} </span>
                      </p>
                      <p><span className="color-azul3"> {etiRP.etiquetas[6].text} </span> <br/>
                          <span className="padding-20px"> {props.propuestaDetallesFront.user.name} </span> <br/>
                          <span className="padding-20px"> {props.propuestaDetallesFront.user.email} </span>  &nbsp; &nbsp;
                      </p>
                      <p><span className="color-azul3"> {etiRP.etiquetas[7].text} </span> <br/>
                        <span className='padding-20px'>{props.propuestaDetallesFront.description} </span>
                      </p>
                      <p>
                        <span className="color-azul3"> {etiRP.etiquetas[8].text} </span> <br/>
                        { props.propuestaDetallesFront.origin?.map((o:any, indexO:any) => (
                            <>
                              <span className='padding-20px'><i className='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>&nbsp;
                                {o.name}</span><br/>
                              <span className='padding-40px'>{o.specification} </span><br/>
                            </>  
                        ))}    
                        
                      </p>
                      <p><span className="color-azul3"> {etiRP.etiquetas[9].text} </span> <br/>
                      
                        { props.propuestaDetallesFront.processxfrequency?.map((pf:any, indexO:any) => (
                            <>
                              <span className='padding-20px'><i className='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>&nbsp;
                                {pf.acronym}&nbsp;/&nbsp;{pf.processname}</span>
                              <span className={pf.clasexEstatusIcono}>{pf.state_process.pt_state_description} </span><br/>
                            </>  
                        ))}  
                      </p>
                    </div>
                  </>)
              }
              <br/>
            </div>  

          {/* Tipo de modificación */}
            <div>
              <p className="h6 color-azul4 ">{etiRP.contenido[11].text}</p> 
              <div className='padding-left-1r'>
                {/*catálogo de decisiones*/}
                { miCatDecisionesFront?.map((cd:any, indexO:any) => (
                  (x0 =  `catD_${miPDProposalFront.id}_${cd.id}`),
                  (x1 =  `selPC_${miPDProposalFront.id}_${cd.id}`),
                  (x2 =  `selPCO_${miPDProposalFront.id}_${cd.id}`),
                  (x3 =  `selNPC_${miPDProposalFront.id}_${cd.id}`),
                  (x4 =  `selNPCO_${miPDProposalFront.id}_${cd.id}`),
                  (x5 =  `selPCOHH_${miPDProposalFront.id}_${cd.id}`),
                  (x6 =  `selPCOHHMM_${miPDProposalFront.id}_${cd.id}`),
                  (x7 =  `selPCOAA_${miPDProposalFront.id}_${cd.id}`),
                  (x8 =  `selPCOMM_${miPDProposalFront.id}_${cd.id}`),
                  (x9 =  `selPCODD_${miPDProposalFront.id}_${cd.id}`),
                  (<>
                    { cd.visible &&
                      (<>
                          {/* radios (no procede, prevista y no prevista) los 2 últimos con artículo en tooltip*/}
                            <div className="divCatD_RP">
                              <input 
                                  type="radio"
                                  id={x0} 
                                  onClick={ cambiaRadioDecision } 
                                  checked={cd.activo} 
                                  disabled={cd.disabled} />
                            </div>
                            <div style={{display:"inline-block"}}>
                                <span className='color-azul3 padding-botton-1r'> {cd.name} </span> 
                                {/* artículos a prevista y no prevista */}
                                { cd.id == 2  &&
                                  (<>
                                    <span className="color-azul3">
                                      <button data-tip data-for="articulo9" className="btnRT9"> {etiRP.contenido[11].text2} </button>
                                      <ReactTooltip id="articulo9" type="info"  place="right" multiline  >
                                        {articulos.articles[9].ch} <br/><br/>
                                        Articulo: 9<br /> {articulos.articles[9].description}<br /><br />
                                      </ReactTooltip>
                                    </span>  
                                  </>)
                                }
                                { cd.id == 3 &&
                                  (<>
                                    <span className="color-azul3">
                                      <button data-tip data-for="articulo19" className="btnRT9"> {etiRP.contenido[11].text3}</button>
                                      <ReactTooltip id="articulo19" type="info"  place="right" multiline  >
                                        {articulos.articles[9].ch} <br/><br/>
                                        Articulo: 19<br /> {articulos.articles[19].description}<br /><br />
                                      </ReactTooltip>
                                    </span>  
                                  </>)
                                }
                            </div>
                          <br/> 

                          {/* div's No precede, Prevista, No prevista */}

                            {/* 1 - no procede - comentario*/}
                            { (cd.id == 1 && cd.activo) &&
                                (<>
                                    <div className='padding-left-2r'>
                                        <p>{etiRP.contenido[14].text}</p> 
                                        <textarea 
                                            id={`desComentario_${cd.id}`}  
                                            className="textareaPropuesta" 
                                            onChange={ armaComentario } 
                                            value={ comentarioFront }
                                          /*  value={ cd.commentary } */
                                            disabled={cd.disabled} 
                                        >
                                        </textarea>  
                                        <br/><br/>
                                    </div> 
                                </>)
                            }
                            
                            {/* 2 - prevista - ciclo && anio (en caso de otro) */} 
                            { (cd.id == 2 && cd.activo) &&
                                (<>
                                  <div className='padding-left-2r'>
                                      {/* ciclo */}
                                      <div className="container">
                                        <div className="row">
                                          <div className="col-sm">
                                            <label> Ciclo: &nbsp; </label>
                                            {miPDProposalFront.sent
                                              ? (<label className='border-1x padding-02r color-azul3'> {cd.cycle.name}  </label> ) 
                                              : (<>
                                                  <div className="selectdiv">    
                                                    <select id={x1} onChange={ cambiaCiclo } >
                                                      { miCatCiclosFront?.map((cc:any, indexCC:any) => (
                                                        <option 
                                                          label={cc.name} 
                                                          value={cc.id} 
                                                          selected={cc.activo}
                                                        >
                                                        </option>
                                                      ))}
                                                    
                                                    </select>
                                                  </div>
                                                  <br/><br/>
                                                </>)
                                            }
                                          </div>
                                        </div>
                                      </div>  

                                      {/* periodo cuando se selecciono en Ciclo ->"Otro" */}
                                      { swOtroCicloFront &&
                                         (<>
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-8">
                                                    { props.miPropuestaDetalle.frecuenciaUND==false
                                                      ? (<>
                                                          <label> Periodo:  </label> 
                                                          <div className="selectdivRP"> 
                                                              <select  id={x2} onChange={ cambiaCicloOtro } >
                                                                { miCatCiclosOtrosFront?.map((cco:any, indexCC:any) => (
                                                                  <option 
                                                                      label={cco.name} 
                                                                      value={cco.id} 
                                                                      selected={cco.activo}
                                                                  >
                                                                  </option>
                                                                ))}
                                                              </select>&nbsp;
                                                          </div>
                                                        </>)
                                                      : (<>  
                                                            {/* frecuencia Única o No Determinada */}
                                                            <label> Periodo:  </label> <br/>
                                                            { frecUNDStore?.map((f:any, indexFUND:any) => (
                                                              <>
                                                                <div className="divFrecUND">
                                                                  <input 
                                                                      type="radio"
                                                                      id={indexFUND} 
                                                                      checked={f.activo} 
                                                                      onClick={ cambiaRadioFrecuenciaUND } />
                                                                </div>
                                                                <div style={{display:"inline-block"}} className="noBR">
                                                                  <span className='color-azul3 '> {f.name}&nbsp;&nbsp; </span> 
                                                                </div>
                                                              </>
                                                            ))}
                                                            {frecUNDSelecStore=='Anual' &&
                                                               (<>
                                                                  <div className="selectdivRP"> 
                                                                      <select id={x7} onChange={ cambiaCicloOtroAA } >
                                                                        { miCatCiclosOtrosFrontAA?.map((ccoaa:any, indexCCAA:any) => (
                                                                          <option 
                                                                              label={ccoaa.name} 
                                                                              value={ccoaa.id} 
                                                                              selected={ccoaa.activo} >
                                                                          </option>
                                                                        ))}
                                                                      </select>&nbsp;
                                                                  </div>
                                                               </>)   
                                                            }
                                                            {frecUNDSelecStore=='Mensual' &&
                                                               (<>
                                                                 <div className="selectdivRP"> 
                                                                      <select id={x8} onChange={ cambiaCicloOtroMM } >
                                                                        { miCatCiclosOtrosFrontMM?.map((ccomm:any, indexCCMM:any) => (
                                                                          <option 
                                                                              label={ccomm.name} 
                                                                              value={ccomm.id} 
                                                                              selected={ccomm.activo} >
                                                                          </option>
                                                                        ))}
                                                                      </select>&nbsp;
                                                                  </div>
                                                               </>)   
                                                            }
                                                            {frecUNDSelecStore=='Diaria' &&
                                                               (<>
                                                                 <div className="selectdivRP"> 
                                                                      <select id={x9} onChange={ cambiaCicloOtroDD } >
                                                                        { miCatCiclosOtrosFrontDD?.map((ccodd:any, indexCCDD:any) => (
                                                                          <option 
                                                                              label={ccodd.name} 
                                                                              value={ccodd.id} 
                                                                              selected={ccodd.activo} >
                                                                          </option>
                                                                        ))}
                                                                      </select>&nbsp;
                                                                  </div>
                                                               </>)   
                                                            }
                                                        </>)
                                                    }
                                                    </div> 
                                                    {/* frecuencia AAAA-MM-DD hh */}
                                                    { props.miPropuestaDetalle.frecuenciaHH &&
                                                      (<>
                                                        <div className="col-sm-4">
                                                          <label> Horario:  </label> 
                                                          <div className="selectdivRP"> 
                                                              <select id={x5} onChange={ cambiaCicloOtroHH } >
                                                                { miCatCiclosOtrosFrontHH?.map((ccohh:any, indexCChh:any) => (
                                                                  <option 
                                                                      label={ccohh.name} 
                                                                      value={ccohh.id} 
                                                                      selected={ccohh.activo} >
                                                                  </option>
                                                                ))}
                                                              </select>&nbsp;
                                                          </div>  
                                                        </div>
                                                      </>)
                                                    }
                                                    {/* frecuencia AAAA-MM-DD hh:mm */}
                                                    { props.miPropuestaDetalle.frecuenciaHHMM &&
                                                      (<>
                                                        <div className="col-sm-4">
                                                          <label> Horario:  </label>
                                                          <div className="selectdivRP">  
                                                            <select id={x6} onChange={ cambiaCicloOtroHHMM } >
                                                              { miCatCiclosOtrosFrontHHMM?.map((ccomm:any, indexCCmm:any) => (
                                                                <option 
                                                                    label={ccomm.name} 
                                                                    value={ccomm.id} 
                                                                    selected={ccomm.activo} >
                                                                </option>
                                                              ))}
                                                            </select>&nbsp;
                                                          </div>
                                                        </div>
                                                      </>)
                                                    }
                                                </div>
                                            </div> 
                                         </>)
                                      }
                                  </div> 
                                </>)
                            }

                            {/* no prevista */}
                            { cd.id == 3 && cd.activo &&
                               (<>
                                  <div className='padding-left-2r'>
                                      {/* ciclo */}
                                      <div className="container">
                                        <div className="row">
                                          <div className="col-sm">
                                            <label> Ciclo: &nbsp; </label>
                                            { miPDProposalFront.sent
                                              ? (<>
                                                  <label className='border-1x padding-02r color-azul3'>  {cd.cycle.name}  </label> 
                                                
                                                  {/* justificación */}
                                                  <p>{etiRP.contenido[16].text}</p>

                                                  {/* lista de archivos */}
                                                  <label className='border-1x padding-02r color-azul3 width-70 '>
                                                    {etiRP.contenido[17].text} &nbsp;  <br />
                                                    {cd.files?.map((f:any, indexF:any) => (
                                                        <>
                                                          <a href={f.descarga} target="_blank" className="text-link cursorHand">
                                                              <span className='padding-20px cursorHand'>
                                                                <i className='mdi mdi-checkbox-marked color-azul2 font-size-12'></i>
                                                                {f.name}
                                                              </span>
                                                          </a><br/>
                                                        </>  
                                                    ))} 
                                                  </label>  
                                                </>) 
                                              : (<>
                                                  <div className="selectdiv"> 
                                                    <select id={x3} onChange={ cambiaCiclo } >
                                                      { miCatCiclosFront?.map((cc:any, indexCC:any) => (
                                                        <option 
                                                          label={cc.name} 
                                                          value={cc.id} 
                                                          selected={cc.activo}
                                                        >
                                                        </option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                </>)
                                            }
                                          </div>
                                        </div>
                                      </div> 

                                      {/* periodo cuando se selecciono en Ciclo ->"Otro" */}
                                      { swOtroCicloFront  && 
                                        (<>
                                           <div className="container">
                                              <div className="row">
                                                  <div className="col-sm-8">
                                                  { props.miPropuestaDetalle.frecuenciaUND==false
                                                      ? (<>
                                                          <label>Periodo:</label> 
                                                          <div className="selectdivRP"> 
                                                              <select id={x2} onChange={ cambiaCicloOtro }  >
                                                                { miCatCiclosOtrosFront?.map((cco:any, indexCC:any) => (
                                                                  <option 
                                                                      label={cco.name} 
                                                                      value={cco.id} 
                                                                      selected={cco.activo} >
                                                                  </option>
                                                                ))}
                                                              </select>
                                                          </div>
                                                          </>)
                                                      : (<>  
                                                            {/* frecuencia Única o No Determinada */}
                                                            <label> Periodo:  </label> <br/>
                                                            { frecUNDStore?.map((f:any, indexFUND:any) => (
                                                              <>
                                                                <div className="divFrecUND">
                                                                  <input 
                                                                      type="radio"
                                                                      id={indexFUND} 
                                                                      checked={f.activo} 
                                                                      onClick={ cambiaRadioFrecuenciaUND } />
                                                                </div>
                                                                <div style={{display:"inline-block"}} className="noBR">
                                                                  <span className='color-azul3 '> {f.name} </span> 
                                                                </div>
                                                              </>
                                                            ))}
                                                            {frecUNDSelecStore=='Anual' &&
                                                               (<>
                                                                  <div className="selectdivRP"> 
                                                                      <select id={x7} onChange={ cambiaCicloOtroAA } >
                                                                        { miCatCiclosOtrosFrontAA?.map((ccoaa:any, indexCCAA:any) => (
                                                                          <option 
                                                                              label={ccoaa.name} 
                                                                              value={ccoaa.id} 
                                                                              selected={ccoaa.activo} >
                                                                          </option>
                                                                        ))}
                                                                      </select>&nbsp;
                                                                  </div>
                                                               </>)   
                                                            }
                                                            {frecUNDSelecStore=='Mensual' &&
                                                               (<>
                                                                 <div className="selectdivRP"> 
                                                                      <select id={x8} onChange={ cambiaCicloOtroMM } >
                                                                        { miCatCiclosOtrosFrontMM?.map((ccomm:any, indexCCMM:any) => (
                                                                          <option 
                                                                              label={ccomm.name} 
                                                                              value={ccomm.id} 
                                                                              selected={ccomm.activo} >
                                                                          </option>
                                                                        ))}
                                                                      </select>&nbsp;
                                                                  </div>
                                                               </>)   
                                                            }
                                                            {frecUNDSelecStore=='Diaria' &&
                                                               (<>
                                                                 <div className="selectdivRP"> 
                                                                      <select id={x9} onChange={ cambiaCicloOtroDD } >
                                                                        { miCatCiclosOtrosFrontDD?.map((ccodd:any, indexCCDD:any) => (
                                                                          <option 
                                                                              label={ccodd.name} 
                                                                              value={ccodd.id} 
                                                                              selected={ccodd.activo} >
                                                                          </option>
                                                                        ))}
                                                                      </select>&nbsp;
                                                                  </div>
                                                               </>)   
                                                            }
                                                         </>)
                                                    }                                                          

                                                  </div>
                                                  { props.miPropuestaDetalle.frecuenciaHH &&
                                                    (<>
                                                      <div className="col-sm-4">
                                                        <label> Horario:  </label> 
                                                        <div className="selectdivRP">
                                                          <select id={x6} onChange={ cambiaCicloOtroHHMM } >
                                                              { miCatCiclosOtrosFrontHHMM?.map((ccomm:any, indexCCmm:any) => (
                                                                <option 
                                                                    label={ccomm.name} 
                                                                    value={ccomm.id} 
                                                                    selected={ccomm.activo} >
                                                                </option>
                                                              ))}
                                                          </select>&nbsp;
                                                        </div>
                                                      </div>
                                                    </>)
                                                  }
                                                  { props.miPropuestaDetalle.frecuenciaHHMM &&
                                                    (<>
                                                      <div className="col-sm-4">
                                                        <label> Horario:  </label> 
                                                        <div className="selectdivRP">
                                                          <select id={x5} onChange={ cambiaCicloOtroHH } >
                                                            { miCatCiclosOtrosFrontHHMM?.map((ccomm:any, indexCCmm:any) => (
                                                              <option 
                                                                  label={ccomm.name} 
                                                                  value={ccomm.id} 
                                                                  selected={ccomm.activo} >
                                                              </option>
                                                            ))}
                                                          </select>&nbsp;
                                                        </div>
                                                      </div>
                                                    </>)
                                                  }
                                              </div>
                                            </div>
                                        </>)
                                      }

                                      {/*justicación - dropzone */}
                                      {/* <GeneraDropzone /> */}
                                      {miPDProposalFront.sent == false &&
                                        ( <>
                                              <p >{etiRP.contenido[16].text}</p>
                                              <MyDropzone /> 
                                        </>)
                                      }
                                      <br/>
                                  </div> 
                                </>)
                            }
                      
                      </>)
                    }
                  </>) 
                ))}  
              </div>
              {/* <input ng-if="page.decProxPF.decision.id!=catDec.id" name="catDec1_1226" id="1catDec1_1226" type="radio" class="ng-scope" ng-click="page.opencloseDivRadio(decPro.id + '_' + depProItem.id, catDec.id,'content',indexPF); page.DetectChange(decPro.id + '_' + depProItem.id); page.decSendDecide(catDec.id);" style=""> */}
            </div>

          {/* cat Evidencias */}
            <div className=' padding-top-2r'>
              { (miDecisionFront.id == 2 || miDecisionFront.id == 3) //entra para prevista y no prevista
                && (<>
                    <p className="h6 color-azul4 "> {etiRP.contenido[12].text} &nbsp;
                        <span className="color-azul3">
                          <button data-tip data-for="articulo9b" className="btnRT9"> {etiRP.contenido[12].text2} </button>
                          <ReactTooltip id="articulo9b" type="info"  place="right" multiline >
                            {articulos.articles[9].ch} <br/><br/>
                            Articulo: 9<br /> {articulos.articles[9].description}<br /><br />
                          </ReactTooltip>
                        </span> 
                    </p>
                    <div className='padding-left-1r noBR'>
                      { miCatEvidenciasFront?.map((ce:any, indexO:any) => (
                        (x5 =  `catE_${miPDProposalFront.id}_${ce.id}`),
                        (<>
                          <div className="divCatD_RP ">
                            <input 
                                type="checkbox"
                                id={x5} 
                                onClick={ cambiaCheckEvidencias } 
                                checked={ce.activo} 
                                disabled={ce.disabled} />
                          </div>
                          <div style={{display:"inline-block"}}><span className=' padding-botton-1r' title={ce.name}> {ce.name} </span> </div>
                          <br/>
                        </>) 
                      ))}  
                    </div>
                  </>)
              }
            </div>

          {/* cat Principios */}
            <div className='padding-top-2r'>
              { miDecisionFront.id == 2  //entra solo para prevista
                  && (<>
                      <p className="h6 color-azul4 ">{etiRP.contenido[13].text} &nbsp;
                          <span className="color-azul3">
                            <button data-tip data-for="articulo10" className="btnRT9"> {etiRP.contenido[13].text2} </button>
                            <ReactTooltip id="articulo10" type="info"  place="right" multiline >
                              {articulos.articles[10].ch} <br/><br/>
                              Articulo: 10<br /> {articulos.articles[10].description}<br /><br />
                            </ReactTooltip>
                          </span> 
                      </p>
                      <div className='padding-left-1r noBR'>
                        { miCatPrincipiosFront?.map((cp:any, indexP:any) => (
                          (x6 =  `catP_${miPDProposalFront.id}_${cp.id}`),
                          (<>
                            <div className="divCatD_RP ">
                              <input 
                                  type="checkbox"
                                  id={x6} 
                                  onClick={ cambiaCheckPrincipios } 
                                  checked={cp.activo} 
                                  disabled={cp.disabled} />
                            </div>
                            <div style={{display:"inline-block"}}><span className=' padding-botton-1r' title={cp.name}> {cp.name} </span> </div>
                            
                            {/*  incrementa - decrementa */}
                            <div className='padding-left-2r noBR'>
                              { miPDProposalFront.sent
                                ? (<>
                                    {cp.hitId == 0
                                      &&(<> {cp.hitName} (incremento o decremento)</>)
                                    }
                                    {cp.hitId == 1
                                      &&(<><i className="mdi mdi-arrow-up colorBlue1 Font14"></i>   {cp.hitName}</>)
                                    }
                                    {cp.hitId == -1
                                      &&(<><i className="mdi mdi-arrow-down colorBlue1 Font14"></i> {cp.hitName}</>)
                                    }
                                  </>)
                                : (<>
                                    { (cp.activo && cp.id != 6)
                                      && (<>
                                        { cp.hitOpciones?.map((ho:any, indexHO:any) => (
                                          (x7 =  `catPHit_${miPDProposalFront.id}_${cp.id}_${ho.id}`),
                                          (<>
                                            <div className="divCatD_RP ">
                                              <input 
                                                  type="radio"
                                                  id={x7} 
                                                  onClick={ cambiaRadioPrincipiosHit } 
                                                  checked={ho.activo}
                                                  disabled={cp.disabled} 
                                                  />
                                            </div>
                                            <div style={{display:"inline-block"}}>
                                              <span className='padding-botton-1r' title={ho.name}>
                                                {indexHO == 0
                                                  ?(<><i className="mdi mdi-arrow-up colorBlue1 Font14"></i>   {ho.name}</>)
                                                  :(<><i className="mdi mdi-arrow-down colorBlue1 Font14"></i> {ho.name}</>)
                                                }
                                              </span> 
                                            </div>&nbsp;&nbsp;                                  
                                          </>)
                                        ))}
                                        </>)      
                                    }
                                </>)
                              }
                            </div>
                          </>) 
                        ))}  
                      </div>
                    </>)
              }
            </div>
          <br /> 
        </div>

      {/* Botones */}
        <hr />
        <div id="SlidingPanel_pie">
          <div className='text-right padding-botton-1r'>
            { miPDProposalFront.sent == false &&
              (<>
                { swBotonGuardarFront  
                    ? <> <button onClick={botonGuardar} className="btn btn-activo">  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span></button>&nbsp;</> 
                    : <> <button className="btn btn-inactivo" disabled>  <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[2].text, }} ></span> </button>&nbsp;</> 
                }
                { swBotonEnviarFront 
                    ? <> <button onClick={botonEnviar} className="btn btn-activo"> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[3].text, }} ></span> </button>&nbsp;</> 
                    : <> <button className="btn btn-inactivo" disabled> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[3].text, }} ></span> </button>&nbsp;</> 
                  }
              </>)
            } 
            <button onClick={botonCerrar}  className="btn btn-sinColor"> <span dangerouslySetInnerHTML={{ __html: etiGlobal.botones[1].text, }} ></span> </button>&nbsp;
          </div>
        </div>
        
     </>
    );
}
